"use strict";
exports.__esModule = true;
exports.translator = void 0;
var format_1 = require("./format");
var utils_1 = require("./utils");
function translator(opts) {
    var library = {};
    var fallbackLanguage = opts.fallbackLanguage;
    var hasLanguage = function (language) {
        return !!library[language];
    };
    var addLanguage = function (language, registry) {
        library[language] = utils_1.flattenObject(registry);
    };
    var translate = function (_a) {
        var key = _a.key, _b = _a.values, values = _b === void 0 ? {} : _b, _c = _a.language, language = _c === void 0 ? fallbackLanguage : _c;
        var registry = library[language];
        var isTranslated = !!(registry && typeof registry[key] === 'string');
        if (!isTranslated) {
            registry = library[fallbackLanguage];
        }
        if (registry && typeof registry[key] === 'string') {
            return {
                value: format_1.format(registry[key], values),
                isTranslated: isTranslated
            };
        }
        return {
            value: key || '',
            isTranslated: false
        };
    };
    if (opts.library) {
        Object.keys(opts.library).forEach(function (key) {
            addLanguage(key, opts.library[key]);
        });
    }
    return {
        translate: translate,
        addLanguage: addLanguage,
        hasLanguage: hasLanguage
    };
}
exports.translator = translator;
//# sourceMappingURL=core.js.map